import React from 'react';
import { Alert } from '../Alert/Alert';
import { useSystemNotifications } from '../../hooks/useSystemNotifications';
import './SystemNotificationBanner.scss';

export const SystemNotificationBanner = () => {
  const { notifications, hideNotification } = useSystemNotifications();

  if (notifications.length === 0) return null;

  return (
    <>
      {notifications.map((notification) => (
        <Alert
          key={notification.id}
          className='system-notification-banner'
          severity='warning'
          hidden={false}
          handleClose={() => hideNotification(notification.id)}
        >
          <div className='system-notification-message'>{notification.message}</div>
        </Alert>
      ))}
    </>
  );
};
